import { createActions } from 'redux-actions';
import { News } from './types';

const { getNews } = createActions('GET_NEWS');
const { getNewsSuccess } = createActions<News[]>('GET_NEWS_SUCCESS');

export { getNews, getNewsSuccess };
